import { SwalMessage, ToastMessage } from '../../Tools';

// initial
var Profile = (function () {
    let form;

    // adres işlemleri
    var addressHandle = function () {
        // teslimat adresi kaydetme
        $(document).on('click', '[data-canvas-save="shipping"]', function (event) {
            event.preventDefault();

            const shippingForm = event.target.closest('[data-form="shipping"]');
            let button = this;

            // telefon düzenleme
            var values = $(shippingForm).serializeArray();

            $.ajax({
                url: apiUrl + '/UserShippingAddress',
                type: 'POST',
                dataType: 'json',
                data: values,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    $(shippingForm).find('.invalid-feedback').empty();
                    $(shippingForm).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = shippingForm.querySelector('[name="' + name + '"]');

                        element.classList.add('is-invalid');

                        let valid = element.closest('div').querySelector('.invalid-feedback');
                        if (valid) {
                            valid.style.display = 'block';
                            valid.innerHTML = message;
                        }
                    });
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    SwalMessage(
                        {
                            type: 'success',
                            text: xhr.text ?? xhr.message,
                            confirmButton: translate.ok_button
                        },
                        function () {
                            location.reload();
                        }
                    );
                }
            });
        });
        // teslimat adresi kaydetme iptal
        $(document).on('click', '[data-canvas-close="shipping"]', function (event) {
            event.preventDefault();
            $('#canvasShippings [data-bs-dismiss="offcanvas"]').click();
        });

        // fatura adresi kaydetme
        $(document).on('click', '[data-canvas-save="invoice"]', function (event) {
            event.preventDefault();

            const invoiceForm = event.target.closest('[data-form="invoice"]');
            //console.log(invoiceForm);
            let button = this;

            // telefon düzenleme
            var values = $(invoiceForm).serializeArray();

            $.ajax({
                url: apiUrl + '/UserInvoiceAddress',
                type: 'POST',
                dataType: 'json',
                data: values,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    $(invoiceForm).find('.invalid-feedback').empty();
                    $(invoiceForm).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = invoiceForm.querySelector('[name="' + name + '"]');

                        element.classList.add('is-invalid');

                        let valid = element.closest('div').querySelector('.invalid-feedback');
                        if (valid) {
                            valid.style.display = 'block';
                            valid.innerHTML = message;
                        }
                    });
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    SwalMessage(
                        {
                            type: 'success',
                            text: xhr.text ?? xhr.message,
                            confirmButton: translate.ok_button
                        },
                        function () {
                            location.reload();
                        }
                    );
                }
            });
        });
        // fatura adresi kaydetme iptal
        $(document).on('click', '[data-canvas-close="invoice"]', function (event) {
            event.preventDefault();
            $('#canvasInvoices [data-bs-dismiss="offcanvas"]').click();
        });

        // adres silme
        $(document).on('click', '[data-address-remove]', function (event) {
            event.preventDefault();

            let block = event.target.closest('.block');
            let userId = block.getAttribute('data-user-id');
            let addressName = block.getAttribute('data-address-name');
            let type = block.getAttribute('data-address-type');

            let button = this;

            $.ajax({
                url: apiUrl + '/UserAddressRemove',
                type: 'POST',
                dataType: 'json',
                data: {
                    user_id: userId,
                    name: addressName,
                    type: type
                },
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    ToastMessage('1', translate.address_remove, xhr.responseJSON.text ?? xhr.responseJSON.message);
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    ToastMessage('0', translate.address_remove, xhr.text ?? xhr.message);
                    location.reload();
                }
            });
        });
    };

    var handle = function () {};

    return {
        init: function () {
            form = document.querySelector('#address-container');
            if (!form) {
                return;
            }
            handle();
            addressHandle();

            // console.log('profileeee');
        }
    };
})();

$(function () {
    Profile.init();
});
